import React from 'react';
import { connect } from 'react-redux';
import HttpStatus from 'http-status-codes';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment, faMoneyBill, faPencil, faDollarSign, faTimes, faTrash, faCheck, faPlus, faCoffee } from '@fortawesome/pro-solid-svg-icons'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// @material-ui/icons
import MoreVert from "@material-ui/icons/MoreVert";
import Add from "@material-ui/icons/Add";
import AttachFile from "@material-ui/icons/AttachFile";
import Folder from "@material-ui/icons/Folder";
import Chat from "@material-ui/icons/Chat";
import Contacts from "@material-ui/icons/Contacts";
import Payment from "@material-ui/icons/Payment";
import LocationCity from "@material-ui/icons/LocationCity";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import { primaryColor } from "assets/jss/material-dashboard-pro-react.jsx";

import { store } from '../../redux/store';
import { SET_PAGE_TITLE } from '../../redux/types';

import { Route } from 'react-router-dom';

import defaultUserImage from "assets/img/no_profile.png";
import cellfind from "assets/img/cellfind.png";
import panacea from "assets/img/panacea.jpg";
import simigenix from "assets/img/simigenix.png";
import Ribbon from '../../components/Ribbon/Ribbon';
import Api from '../../api/Api.js';
import CustomerEndpoints from '../../api/CustomerEndpoints';
import moment from 'moment';
import FileUploadButton from '../../components/CustomUpload/FileUploadButton';
import FileEndpoints from '../../api/FileEndpoints';
import Adhoc from './ViewCustomerTabs/Adhoc';
import Addresses from './ViewCustomerTabs/Addresses';
import ContactsTab from './ViewCustomerTabs/Contacts';

import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ReplyIcon from '@material-ui/icons/Reply';

import NotesList from "components/Notes/NotesList";

import * as actions from '../../redux/actions';
import Files from './ViewCustomerTabs/Files';
import { replace } from 'connected-react-router';
import Empty from '../../components/Empty/Empty';
import Note from './ViewCustomerTabs/Note';
import ChangeAccountNumberDialog from './ViewCustomerTabs/Dialogs/ChangeAccountNumberDialog';
import ChargeAdhocDialog from './ViewCustomerTabs/Dialogs/ChargeAdhocDialog';
import Loading from '../../components/Loading/Loading';
import ImageEndpoints from '../../api/ImageEndpoints';
import PictureUpload from '../../components/CustomUpload/PictureUpload';
import FileBlock from '../../components/Files/FileBlock';
import SmallModal from '../../components/Modal/SmallModal';
import { CircularProgress, Snackbar, ButtonBase } from '@material-ui/core';
import NotesEndpoints from '../../api/NotesEndpoints';
import CustomerProductItem from './CustomerProductItem';
import AsyncLoadingWrapper from '../../components/Loading/AsyncLoadingWrapper';
import SetSalesPersonDialog from './ViewCustomerTabs/Dialogs/SetSalesPersonDialog';
import EditCustomerDialog from './ViewCustomerTabs/Dialogs/EditCustomerDialog';
import AddProductDialog from './ViewCustomerTabs/Dialogs/AddProductDialog';
import NotificationModal from '../../components/Modal/NotificationModal';

const TabItemContainer = (props) => {
    return (
        <GridContainer style={{ position: 'relative', minHeight: 201, width: '100%', overflowY: 'auto', overflowX: 'hidden', ...props.style }}>
            <GridItem xs={12}>
                {
                    props.fab ?
                        <div style={{ paddingRight: 10, textAlign: 'center' }}>
                            {props.children}
                        </div>
                        :
                        props.children
                }
            </GridItem>
        </GridContainer>
    );
}

class ViewCustomer extends React.Component {

    constructor(props) {
        super(props);

        const { id, tab, tab_id } = this.props.match.params;

        const index = props.customers.findIndex(x => x.id == id);

        if (props.customers[index])
            store.dispatch({ type: SET_PAGE_TITLE, payload: props.customers[index].account_no + " - " + props.customers[index].name })

        this.state = {
            customerIndex: index,
            customer_id: id,
            customer: props.customers[index],
            hasDetail: false,
            files: {},
            selectedFolder: {},
            moreInfoExpanded: false,
            newNoteFiles: [],
            note_files: [],
            initialTab: tab || 0,
            tab_id,
            noteMessage: '',
            replying: {},
            product_list: [],
            dialog: {
                note: false,
                account_no: false,
                adhoc: false,
                suspend: false,
                close: false,
                activate: false,
                validate: false,
                noteLoading: false,
                edit_customer: false,
                sales_person: false,
                add_product: false,
                error: false
            },
            errorMessage: '',
            snackbarOpen: false,
            snackbarColor: 'danger',
            snackbarMessage: 'Not Message',
            snackbarPlace: 'tc'
        }
    }

    timeout;
    snackbar = (dismiss, message = '', color = 'danger', place = this.state.snackbarPlace) => {
        clearTimeout(this.timeout);
        this.setState(
            { snackbarOpen: !dismiss, snackbarColor: color, snackbarMessage: message, snackbarPlace: place },
            () => this.timeout = setTimeout(() => this.setState({ snackbarOpen: false }), 10000)
        );
    };

    suspend() {
        Api.get(CustomerEndpoints.suspend, { id: this.state.customer_id })
            .then(() => this.RefreshCustomer())
    }

    close() {
        Api.get(CustomerEndpoints.close, { id: this.state.customer_id })
            .then(() => this.RefreshCustomer())
    }

    activate() {
        Api.get(CustomerEndpoints.activate, { id: this.state.customer_id })
            .then(() => this.RefreshCustomer())
    }

    validate() {
        Api.get(CustomerEndpoints.validate, { id: this.state.customer_id })
            .then(() => this.RefreshCustomer())
            .catch((e) => {
                if (e.statusCode == HttpStatus.BAD_REQUEST) {
                    this.setState({ errorMessage: "Please complete the account details before validating. This includes at a minimum Customer Name and Customer Address", dialog: { ...this.state.dialog, error: false } })
                } else {
                    console.error(e);
                }
            })
    }

    addNote() {
        this.setState({ dialog: { ...this.state.dialog, noteLoading: true } }, () => {

            Api.post(
                NotesEndpoints.post,
                {
                    message: this.state.noteMessage,
                    files: this.state.note_files.map(x => x.id),
                    bind: 'account',
                    bind_id: this.state.customer_id,
                    reply_to: this.state.replying.id ? this.state.replying.id : null
                }
            )
                .then(() => this.setState({ dialog: { ...this.state.dialog, note: false, noteLoading: false }, replying: {}, noteMessage: '', newNoteFiles: [], note_files: [] }, () => this.RefreshCustomer()));
        })
    }

    componentDidMount() {
        this.RefreshCustomer();
        this.RefreshFiles();
        if (this.state.tab_id && this.state.initialTab == 1) {
            this.GetFolderContents(this.state.tab_id);
        }
    }

    getImage(file, index) {
        let reader = new FileReader();
        reader.onloadend = () => {
            var newnew = [].concat(this.state.newNoteFiles);
            newnew[index].image = reader.result;
            this.setState({ newNoteFiles: newnew });
        };

        var fileExt = file.name.split('.').pop().toLowerCase();

        if (file && (fileExt === 'jpg' || fileExt === 'png' || fileExt === 'jpeg')) {
            reader.readAsDataURL(file);
        }
    }

    RefreshCustomer() {
        Api.get(CustomerEndpoints.detail, { id: this.state.customer_id }).
            then(({ data }) => {
                this.setState({ customer: data, hasDetail: true });
            })
            .catch((e) => {
                this.setState({ customer: { ...this.state.customer, sales_user: { name: "Error" } } });
                console.error(e);
            });

        this.props.getNotes('customer', this.state.customer_id);
    }

    RefreshFiles() {
        Api.get(FileEndpoints.customerList, { id: this.state.customer_id }).
            then(({ data }) => {
                this.setState({ files: data });
            })
            .catch((e) => {
                this.setState({ files: 'Error' });
                console.error(e);
            });
    }

    GetFolderContents(folder_name) {
        Api.get(FileEndpoints.folderContent, { name: folder_name, account_id: this.state.customer_id }).
            then(({ data }) => {
                this.setState({ currentFolder: data });
            })
            .catch((e) => {
                this.setState({ currentFolder: 'Error' });
                console.error(e);
            });
    }

    dropdown = [
        {
            content: <span><FontAwesomeIcon icon={faComment} />&nbsp; Add Note</span>,
            onClick: () => this.setState({ dialog: { ...this.state.dialog, note: true } })
        },
        {
            content: <span><FontAwesomeIcon icon={faMoneyBill} />&nbsp;&nbsp; Charge Adhoc</span>,
            onClick: () => this.setState({ dialog: { ...this.state.dialog, adhoc: true } })
        },
        {
            content: <span><FontAwesomeIcon icon={faPencil} />&nbsp;&nbsp; Edit Customer</span>,
            onClick: () => this.setState({ dialog: { ...this.state.dialog, edit_customer: true } })
        },
        {
            content: <span><FontAwesomeIcon icon={faDollarSign} />&nbsp;&nbsp; Set Sales Person</span>,
            onClick: () => this.setState({ dialog: { ...this.state.dialog, sales_person: true } })
        },
        {
            content: <span><FontAwesomeIcon icon={faCoffee} />&nbsp;&nbsp; Add Product</span>,
            onClick: () => this.setState({ dialog: { ...this.state.dialog, add_product: true } })
        },

        { content: { divider: true } },

        {
            content: <span><FontAwesomeIcon icon={faPencil} />&nbsp;&nbsp; Change Account Number</span>,
            onClick: () => this.setState({ dialog: { ...this.state.dialog, account_no: true } })
        },
        () =>
        (this.state.customer.active && this.state.customer.validated && !this.state.customer.closed ?
            {
                content: <span><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp; Suspend Account</span>,
                onClick: () => this.setState({ dialog: { ...this.state.dialog, suspend: true } })
            }
            :
            (
                this.state.customer.closed ?
                    { content: { divider: true } }
                    :
                    (
                        this.state.customer.validated ?
                            {
                                content: <span><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp; Activate Account</span>,
                                onClick: () => this.setState({ dialog: { ...this.state.dialog, activate: true } })
                            }
                            :
                            {
                                content: <span><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp; Verify Account</span>,
                                onClick: () => this.setState({ dialog: { ...this.state.dialog, validate: true } })
                            }
                    )
            )
        ),
        () =>
        (!this.state.customer.closed ?
            {
                content: <span><FontAwesomeIcon icon={faTrash} />&nbsp;&nbsp; Close Account</span>,
                onClick: () => this.setState({ dialog: { ...this.state.dialog, close: true } })
            }
            :
            {
                content: <span><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp; Reopen Account</span>,
                onClick: () => this.setState({ dialog: { ...this.state.dialog, activate: true } })
            }
        )
    ];

    changeAccountPicture = (file) => {
        Api.fileUpload(ImageEndpoints.upload, [file], { bind: "account", bind_id: this.state.customer_id })
            .then(({ data }) => {
                this.setState({ customer: { ...this.state.customer, ...data } });
            })
    }

    render() {
        const { classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <Card profile>
                        <div style={{ position: "relative" }}>
                            <Ribbon backgroundColor={this.state.customer.closed ? "#f44" : (this.state.customer.validated ? (this.state.customer.active ? "rgb(68, 221, 68)" : "#fc0") : "#e80")} >
                                {this.state.customer.closed ? "Closed" : (this.state.customer.validated ? (this.state.customer.active ? "Active" : "Suspended") : "Not Verified")}
                            </Ribbon>
                            <CardAvatar style={{ height: 130, width: 130 }} profile>
                                <PictureUpload
                                    style={{ height: 130, width: 130 }}
                                    imgStyle={{ height: 122, width: 122 }}
                                    preview={this.state.customer.image ? ("/api/image/get?id=" + this.state.customer.image) : defaultUserImage}
                                    onImagePicked={(file) => this.changeAccountPicture(file)}
                                />
                            </CardAvatar>
                            <CardAvatar profile style={{ position: 'absolute', bottom: -10, right: 'calc(50% - 75px)', height: 55, width: 55 }}>
                                <img src={(this.state.customer.company === "Cellfind" ? cellfind : (this.state.customer.company === "Panacea" ? panacea : simigenix))} />
                            </CardAvatar>

                            <CustomDropdown
                                hoverColor="rose"
                                buttonIcon={MoreVert}
                                buttonProps={{
                                    round: true,
                                    style: {
                                        position: 'absolute',
                                        top: 5,
                                        right: 10,
                                        marginBottom: "0",
                                        padding: 12
                                    },
                                    color: "white"
                                }}
                                buttonIconProps={{ style: { marginRight: 0, height: 24, width: 24 } }}

                                onClick={(index) => {
                                    if (typeof (this.dropdown[index]) === "function") {
                                        var result = this.dropdown[index]();

                                        if (result.onClick)
                                            result.onClick()
                                    } else
                                        if (this.dropdown[index].onClick)
                                            this.dropdown[index].onClick()
                                }}

                                dropdownHeader="Options"

                                dropdownList={this.dropdown.map(x => (typeof (x) === "function" ? x().content : x.content))}
                            />
                        </div>
                        <CardBody profile>
                            <h3 className={classes.cardCategory} style={{ paddingBottom: 18 }}>{this.state.customer.prepaid ? <span>{(this.state.customer || { account_no: "" }).account_no.substring(3)} - <span style={{ color: 'var(--green)' }}>Prepaid</span></span> : this.state.customer.account_no}</h3>
                            <h4 className={classes.cardTitle} style={{ paddingBottom: 12 }}>{this.state.customer.name}</h4>
                        </CardBody>
                        <ExpansionPanel style={{ boxShadow: 'none', borderRadius: 8, border: 'none', borderTop: 'none', "::before": { content: 'none', display: 'none' } }} expanded={this.state.moreInfoExpanded} onChange={() => this.setState({ moreInfoExpanded: !this.state.moreInfoExpanded })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} >
                                More Info
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <GridContainer>
                                    <GridItem xs={6} style={{ textAlign: 'left', fontWeight: 'bold' }}>
                                        Signed Up
                                    </GridItem>
                                    <GridItem xs={6} style={{ textAlign: 'right' }}>
                                        {this.state.customer.signup_date ? moment(this.state.customer.signup_date).format("YYYY-MM-DD") : "Unknown"}
                                    </GridItem>

                                    <GridItem xs={6} style={{ textAlign: 'left', fontWeight: 'bold' }}>
                                        Reg No:
                                    </GridItem>
                                    <GridItem xs={6} style={{ textAlign: 'right' }}>
                                        {this.state.customer.registration_no ? this.state.customer.registration_no : "N/A"}
                                    </GridItem>

                                    <GridItem xs={6} style={{ textAlign: 'left', fontWeight: 'bold' }}>
                                        VAT No:
                                    </GridItem>
                                    <GridItem xs={6} style={{ textAlign: 'right' }}>
                                        {this.state.customer.vat_no ? this.state.customer.vat_no : "N/A"}
                                    </GridItem>

                                    <GridItem xs={6} style={{ textAlign: 'left', fontWeight: 'bold' }}>
                                        Sales Person:
                                    </GridItem>
                                    <GridItem xs={6} style={{ textAlign: 'right' }}>
                                        {
                                            this.state.customer.sales_id ?
                                                (
                                                    this.state.customer.sales_user ?
                                                        `${this.state.customer.sales_user.name} ${this.state.customer.sales_user.surname || ""}`
                                                        :
                                                        'Loading...'
                                                )
                                                :
                                                'None'
                                        }
                                    </GridItem>

                                </GridContainer>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={8} style={{ position: 'relative' }}>
                    <CustomTabs
                        initialValue={parseInt(this.state.initialTab)}
                        onChange={(index) => store.dispatch(replace(`/customers/view/${this.state.customer_id}/${index}`))}
                        headerColor="rose"
                        tabs={[
                            {
                                tabName: "Notes",
                                tabIcon: Chat,
                                tabContent: (
                                    [
                                        <Route
                                            key="note_list"
                                            exact
                                            path={`/customers/view/(${this.state.customer_id}|${this.state.customer_id}/0)`}
                                            component={() => {
                                                return [
                                                    <TabItemContainer key="notes" fab >
                                                        {
                                                            (this.props.notes[this.state.customer_id] && this.props.notes[this.state.customer_id].length > 0) ?
                                                                <NotesList onNoteClick={(note) => store.dispatch(replace(`/customers/view/${this.state.customer_id}/0/${note.id}`))} notes={this.props.notes[this.state.customer_id] || []} />
                                                                :
                                                                <Empty title="No Notes..." subtitle="Go and make some!" />
                                                        }
                                                    </TabItemContainer>
                                                    ,
                                                    <Fab key="fab" onClick={() => this.setState({ dialog: { ...this.state.dialog, note: true } })} style={{ position: 'absolute', bottom: 12, right: 12 }} color="secondary" aria-label="Add">
                                                        <AddIcon />
                                                    </Fab>
                                                ];
                                            }
                                            }
                                        />,
                                        <Route
                                            key="view_note"
                                            path={`/customers/view/${this.state.customer_id}/0/:tab_id`}
                                            component={(props) => {
                                                const { tab_id } = props.match.params;

                                                if (!this.props.notes[this.state.customer_id]) {
                                                    return <Loading />
                                                }

                                                const note = this.props.notes[this.state.customer_id].find(x => x.id === parseInt(tab_id));

                                                return [
                                                    <TabItemContainer key="note" fab style={{ marginTop: 70, marginBottom: 80 }}>
                                                        <Note {...note} />
                                                    </TabItemContainer>,
                                                    <Fab key="back" variant="extended" onClick={() => store.dispatch(replace(`/customers/view/${this.state.customer_id}/0`))} style={{ position: 'absolute', top: 12, left: 12 }} color="secondary" aria-label="Back">
                                                        <KeyboardArrowLeft />
                                                        Back
                                                    </Fab>
                                                    ,
                                                    <Fab key="reply" variant="extended" onClick={() => this.setState({ dialog: { ...this.state.dialog, note: true }, replying: note })} style={{ position: 'absolute', bottom: 12, right: 12 }} color="primary" aria-label="Reply">
                                                        <ReplyIcon />
                                                        &nbsp;&nbsp;
                                                        Reply
                                                    </Fab>,
                                                ]
                                            }}
                                        />
                                    ]
                                )
                            },
                            {
                                tabName: "Files",
                                tabIcon: Folder,
                                tabContent: (
                                    [
                                        <Route
                                            key="all_files"
                                            exact
                                            path={`/customers/view/${this.state.customer_id}/1`}
                                            component={() => {
                                                return (
                                                    <TabItemContainer style={{ margin: 0 }}>
                                                        <Files
                                                            files={this.state.files}
                                                            customer_id={this.state.customer_id}
                                                            onRefreshRequired={(folder) => {
                                                                this.RefreshFiles();
                                                                if (folder)
                                                                    this.GetFolderContents(folder)
                                                            }}
                                                        />
                                                    </TabItemContainer>
                                                );
                                            }
                                            }
                                        />,
                                        <Route
                                            key="view_folder"
                                            path={`/customers/view/${this.state.customer_id}/1/:tab_id`}
                                            component={(props) => {
                                                const { tab_id } = props.match.params;

                                                if (!this.state.currentFolder || this.state.currentFolder.name !== tab_id) {
                                                    this.GetFolderContents(tab_id);
                                                    return <Loading />;
                                                }

                                                if (this.state.currentFolder === "Error") {
                                                    return <Empty title={"Something went terribly wrong..."} />
                                                }

                                                return (
                                                    <TabItemContainer style={{ margin: 0 }}>
                                                        <Files
                                                            showBack
                                                            files={this.state.currentFolder}
                                                            customer_id={this.state.customer_id}
                                                            onRefreshRequired={(folder) => {
                                                                this.RefreshFiles();

                                                                if (folder)
                                                                    this.GetFolderContents(folder)
                                                                else
                                                                    this.GetFolderContents(tab_id)
                                                            }}
                                                        />
                                                    </TabItemContainer>
                                                );
                                            }}
                                        />
                                    ]
                                )
                            },
                            {
                                tabName: "Adhoc",
                                tabIcon: Payment,
                                tabContent: (
                                    <Adhoc
                                        customer_id={this.state.customer_id}
                                    />
                                )
                            },
                            {
                                tabName: "Addresses",
                                tabIcon: LocationCity,
                                tabContent: (
                                    <TabItemContainer>
                                        <Addresses onRefreshRequired={() => this.RefreshCustomer()} customer_id={this.state.customer_id} physical={this.state.customer.physical} postal={this.state.customer.postal} />
                                    </TabItemContainer>
                                )
                            },
                            {
                                tabName: "Contacts",
                                tabIcon: Contacts,
                                tabContent: (
                                    <ContactsTab
                                        contacts={this.state.customer.account_contact}
                                        customer_id={this.state.customer_id}
                                        refresh={async () => this.RefreshCustomer()}
                                    />
                                )
                            }
                        ]}
                    />
                </GridItem>
                <Dialog
                    open={this.state.dialog.note}
                    onClose={() => this.setState({ dialog: { ...this.state.dialog, note: false }, replying: {} })}
                    fullWidth
                    scroll="body"
                    maxWidth="sm"
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">{this.state.replying.id ? "Reply To" : "New Note"}</DialogTitle>
                    {
                        this.state.replying.id ?
                            <DialogContent>
                                <Note {...this.state.replying} />
                            </DialogContent>
                            :
                            null
                    }
                    <DialogContent>
                        <CustomInput
                            labelText={
                                <span>
                                    Message
                                </span>
                            }
                            id="new_note_message"
                            formControlProps={{
                                fullWidth: true,
                                variant: "outlined",
                            }}
                            inputProps={{
                                autoFocus: true,
                                variant: "outlined",
                                multiline: true,
                                value: this.state.noteMessage,
                                onChange: (e) => this.setState({ noteMessage: e.target.value })
                            }}
                        />
                    </DialogContent>

                    {
                        this.state.note_files.length > 0 ?
                            <DialogContent>
                                <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'space-evenly', alignContent: 'space-around' }}>
                                    {
                                        this.state.newNoteFiles.map(fileObj => {
                                            return (
                                                <FileBlock
                                                    key={fileObj.file.name}
                                                    fileType={fileObj.file.name.split('.').pop().toLowerCase()}
                                                    fileName={fileObj.file.name}
                                                    image={fileObj.image}
                                                    onDelete={() => {
                                                        var filteredNoteFiles = this.state.newNoteFiles.filter(x => x.file.name !== fileObj.file.name);
                                                        var filteredNoteFiles_Server = this.state.note_files.filter(x => x.original_name !== fileObj.file.name);
                                                        var toDelete = this.state.note_files.filter(x => x.original_name === fileObj.file.name);
                                                        toDelete.forEach(x => {
                                                            Api.get(FileEndpoints.delete, x)
                                                                .then(() => {
                                                                    this.setState({ newNoteFiles: filteredNoteFiles, note_files: filteredNoteFiles_Server }, () => this.RefreshFiles())
                                                                })
                                                        });
                                                    }}
                                                />
                                            );
                                        })
                                    }
                                </div>
                            </DialogContent>
                            : null
                    }

                    <DialogActions>
                        {
                            this.state.dialog.noteLoading ?
                                <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                                :
                                [
                                    <Button key="cancel" style={{ marginRight: 'auto' }} round onClick={() => this.setState({ dialog: { ...this.state.dialog, note: false }, replying: {} })} color="rose" simple>
                                        Cancel
                                </Button>
                                    ,
                                    <FileUploadButton
                                        key="fub"
                                        buttonProps={{
                                            round: true,
                                            color: "rose"
                                        }}
                                        uploadProps={{
                                            multiple: true
                                        }}
                                        onFileReceived={(files) => {
                                            var filesArray = [];

                                            var f = 0;
                                            while (files[f]) {
                                                filesArray.push({ file: files[f], image: null });
                                                f++;
                                            }

                                            var lengthBefore = this.state.newNoteFiles.length;
                                            this.setState({ newNoteFiles: this.state.newNoteFiles.concat(filesArray) },
                                                () => {
                                                    for (var i = lengthBefore; i < this.state.newNoteFiles.length; i++)
                                                        this.getImage(this.state.newNoteFiles[i].file, i);
                                                }
                                            );

                                            Api.fileUpload(FileEndpoints.upload, filesArray.map(x => x.file), { account_id: this.state.customer_id })
                                                .then(({ data }) => this.setState({ note_files: this.state.note_files.concat(data) }, () => this.RefreshFiles()))
                                        }}
                                    >
                                        <AttachFile />&nbsp;&nbsp; Attach Document
                                </FileUploadButton>
                                    ,
                                    <Button
                                        key="submit"
                                        onClick={() => this.addNote()}
                                        color="rose"
                                        round
                                    >
                                        {this.state.replying.id ? "Reply" : "Add Note"}
                                        &nbsp;&nbsp;
                                    <Add />
                                    </Button>
                                ]
                        }
                    </DialogActions>
                </Dialog>

                {
                    this.state.product_list ?
                        <AddProductDialog
                            isOpen={this.state.dialog.add_product}
                            onClose={() => this.setState({ dialog: { ...this.state.dialog, add_product: false } })}
                            existing_products={this.state.product_list}
                            customer_id={this.state.customer_id}
                            refresh={() => {
                                Api.get(CustomerEndpoints.productsList, { id: this.state.customer_id })
                                    .then(({ data }) => {
                                        this.setState({ product_list: data });
                                    })
                            }}
                        />
                        : null
                }

                <ChangeAccountNumberDialog
                    customer_id={this.state.customer_id}
                    account_no={(this.state.customer || { account_no: "" }).account_no}
                    prepaid={this.state.customer.prepaid}
                    isOpen={(this.state.dialog || { account_no: '' }).account_no}
                    close={() => this.setState({ dialog: { ...this.state.dialog, account_no: !(this.state.dialog || { account_no: '' }).account_no } })}
                    refresh={(acc) => {
                        this.setState({ customer: { ...this.state.customer, account_no: acc } }, () => {
                            if (this.state.customer)
                                store.dispatch({ type: SET_PAGE_TITLE, payload: this.state.customer.account_no + " - " + this.state.customer.name })
                        });
                    }}
                />

                <ChargeAdhocDialog
                    adhoc_services={this.props.adhoc_services}
                    customer_id={this.state.customer_id}
                    isOpen={this.state.dialog.adhoc}
                    close={() => this.setState({ dialog: { ...this.state.dialog, adhoc: !this.state.dialog.adhoc } })}
                    refresh={() => this.Refre}
                />

                {
                    this.state.hasDetail ?
                        <EditCustomerDialog
                            {...this.state.customer}
                            customer_id={this.state.customer_id}
                            isOpen={this.state.dialog.edit_customer}
                            close={() => this.setState({ dialog: { ...this.state.dialog, edit_customer: !this.state.dialog.edit_customer } })}
                            refresh={(acc) => {
                                this.setState({ customer: { ...this.state.customer, ...acc } }, () => {
                                    if (this.state.customer)
                                        store.dispatch({ type: SET_PAGE_TITLE, payload: this.state.customer.account_no + " - " + this.state.customer.name })
                                })
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.hasDetail ?
                        <SetSalesPersonDialog
                            sales_person={this.state.customer.sales_user}
                            users={this.props.allUsers}
                            customer_id={this.state.customer_id}
                            isOpen={this.state.dialog.sales_person}
                            close={() => this.setState({ dialog: { ...this.state.dialog, sales_person: !this.state.dialog.sales_person } })}
                            refresh={(new_sales_user) => {
                                this.setState({ customer: { ...this.state.customer, sales_user: new_sales_user, sales_id: new_sales_user.id } })
                            }}
                        />
                        :
                        null
                }

                <SmallModal
                    id="suspend"
                    isOpen={this.state.dialog.suspend}
                    accept={() => this.setState({ dialog: { ...this.state.dialog, suspend: false } }, () => this.suspend())}
                    close={() => this.setState({ dialog: { ...this.state.dialog, suspend: false } })}>
                    Are you sure you want to <span style={{ color: primaryColor }}>suspend</span> this account?
                </SmallModal>

                <SmallModal
                    id="activate"
                    isOpen={this.state.dialog.activate}
                    accept={() => { this.setState({ dialog: { ...this.state.dialog, activate: false } }); this.activate(); }}
                    close={() => this.setState({ dialog: { ...this.state.dialog, activate: false } })}>
                    Are you sure you want to <span style={{ color: primaryColor }}>activate</span> this account?
                </SmallModal>

                <SmallModal
                    id="close"
                    isOpen={this.state.dialog.close}
                    accept={() => { this.setState({ dialog: { ...this.state.dialog, close: false } }); this.close(); }}
                    close={() => this.setState({ dialog: { ...this.state.dialog, close: false } })}>
                    Are you sure you want to <span style={{ color: primaryColor }}>close</span> this account?
                </SmallModal>

                <SmallModal
                    id="validate"
                    isOpen={this.state.dialog.validate}
                    accept={() => { this.setState({ dialog: { ...this.state.dialog, validate: false } }); this.validate(); }}
                    close={() => this.setState({ dialog: { ...this.state.dialog, validate: false } })}>
                    Are you sure <span style={{ color: primaryColor }}>all details</span> are <span style={{ color: primaryColor }}>correct</span> to the best of your knowledge?
                </SmallModal>

                <NotificationModal
                    open={this.state.dialog.error}
                    close={() => this.setState({ dialog: { ...this.state.dialog, error: false } })}
                >
                    {this.state.errorMessage}
                </NotificationModal>

                <GridItem xs={12}>
                    <AsyncLoadingWrapper
                        action={() => Api.get(CustomerEndpoints.productsList, { id: this.state.customer_id })}
                        onComplete={({ data }) => {
                            this.setState({ product_list: data });
                        }}
                        onCatch={(e) => {

                        }}
                    >
                        {this.state.product_list.map(x => <CustomerProductItem key={x.id} {...x} product_id={x.id} customer_id={this.state.customer_id} snackbar={this.snackbar} />)}
                    </AsyncLoadingWrapper>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <Card
                            Component={ButtonBase}
                            style={{ height: 64, display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}
                            onClick={() => this.setState({ dialog: { ...this.state.dialog, add_product: true } })}
                        >
                            <FontAwesomeIcon icon={faPlus} size={"3x"} color="#bbb" />
                        </Card>
                    </div>
                </GridItem>

                <Snackbar
                    key="snackbar"
                    place={this.state.snackbarPlace}
                    color={this.state.snackbarColor}
                    message={this.state.snackbarMessage}
                    open={this.state.snackbarOpen}
                    closeNotification={() => this.setState({ snackbarOpen: false })}
                    close
                />

            </GridContainer>
        );
    }
}

const mapStateToProps = (state) => ({
    customers: state.customers.list,
    notes: state.notes.customer,
    allUsers: state.allUsers.list,
    adhoc_services: state.services.adhoc,
    router: state.router,
    query: state.query
})

export default withStyles(userProfileStyles)(connect(mapStateToProps, actions)(ViewCustomer));